import React from 'react';
import {
  Typography,
  Container,
  Row as GridRow,
  Col,
  Spacer,
} from 'design-system';
import { DS_TYPE_LARGE_SCREEN_ROWS, DS_TYPE_SMALL_SCREEN_ROWS } from './typographyShowcaseData';

const Separator = ({ className = '' }) => (
  <div className={['separator', className].filter(Boolean).join(' ')} />
);

export default function TypographyShowcase() {
  return (
    <GridRow>
      <Col xs={12}>
        <div className="design-system-section">
          <Typography variant="h1" className="section-title mb-4">
            Typography Components
          </Typography>
          <Separator className="mb-5" />

          <Container className="typography-category typography-category--flush">
            <Typography variant="h3" className="typography-category-title">
              Large screen
            </Typography>
            <div className="ds-type-spec-table-wrap">
              <table className="ds-type-spec-table">
                <thead>
                  <tr>
                    <th scope="col">Tag</th>
                    <th scope="col">Typestyle</th>
                    <th scope="col">Font size</th>
                    <th scope="col">Font weight</th>
                    <th scope="col">Line height</th>
                    <th scope="col">Letter spacing</th>
                    <th scope="col">Paragraph spacing</th>
                  </tr>
                </thead>
                <tbody>
                  {DS_TYPE_LARGE_SCREEN_ROWS.map((row) => (
                    <tr key={row.tag}>
                      <td>
                        <code className="ds-type-spec-table__tag">{row.tag}</code>
                      </td>
                      <td className="ds-type-spec-table__sample-cell">
                        <Typography variant={row.variant} component="span" className="ds-type-spec-table__sample">
                          {row.label}
                        </Typography>
                      </td>
                      <td>{row.size}</td>
                      <td>{row.weight}</td>
                      <td>{row.lh}</td>
                      <td>{row.letter}</td>
                      <td>{row.para}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Container>

          <Spacer size={4} />

          <Container className="typography-category typography-category--flush">
            <Typography variant="h3" className="typography-category-title">
              Small screen
            </Typography>
            <div className="ds-type-spec-table-wrap">
              <table className="ds-type-spec-table ds-type-spec-table--tokens">
                <thead>
                  <tr>
                    <th scope="col">Typestyle</th>
                    <th scope="col">Font size</th>
                    <th scope="col">Line height</th>
                    <th scope="col">Font weight</th>
                    <th scope="col">Letter spacing</th>
                    <th scope="col">Paragraph spacing</th>
                  </tr>
                </thead>
                <tbody>
                  {DS_TYPE_SMALL_SCREEN_ROWS.map((row) => (
                    <tr key={row.name}>
                      <td className="ds-type-spec-table__sample-cell">
                        <div>
                          <Typography variant={row.variant} component="span" className="ds-type-spec-table__sample">
                            {row.sample}
                          </Typography>
                        </div>
                        <div className="ds-type-spec-table__row-name">{row.name}</div>
                        <code className="ds-type-spec-table__prop">variant=&quot;{row.variant}&quot;</code>
                      </td>
                      <td>
                        <div className="ds-type-spec-table__px">{row.fs}</div>
                        <div className="ds-type-spec-table__token">{row.fsTok}</div>
                      </td>
                      <td>
                        <div className="ds-type-spec-table__px">{row.lh}</div>
                        <div className="ds-type-spec-table__token">{row.lhTok}</div>
                      </td>
                      <td>{row.weight}</td>
                      <td>
                        <div className="ds-type-spec-table__px">{row.letter}</div>
                        <div className="ds-type-spec-table__token">{row.letterTok}</div>
                      </td>
                      <td>
                        <div className="ds-type-spec-table__px">{row.para}</div>
                        <div className="ds-type-spec-table__token">{row.paraTok}</div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Container>

          <Spacer size={4} />
        </div>
      </Col>
    </GridRow>
  );
}
